import React from 'react';
import { WebsiteDesignProps } from './types';
import { Type, ArrowDown, ArrowUpRight } from 'lucide-react';
import { Button } from "@/components/ui/button";

const TypographicPoster: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Type School";

    return (
        <div className="bg-[#FF3333] min-h-screen font-sans text-white selection:bg-white selection:text-[#FF3333]">
            <nav className="p-8 flex justify-between items-start">
                <div className="text-xs font-bold uppercase tracking-widest flex flex-col gap-1">
                    <span>(EST. 2026)</span>
                    <span>LONDON / NEW YORK</span>
                    <span>DESIGN EDUCATION</span>
                </div>
                <div className="text-xs font-bold uppercase tracking-widest text-right flex flex-col gap-1 items-end">
                    <Button variant="link" className="text-white p-0 h-auto font-bold hover:no-underline hover:opacity-70">MENU</Button>
                </div>
            </nav>

            <main className="container mx-auto px-8 pt-12 pb-24">
                <div className="border-t-2 border-white mb-4"></div>
                <h1 className="text-[12vw] font-bold leading-[0.8] mb-12 break-words text-white tracking-tighter">
                    {schoolName?.split(' ').map((word, i) => (
                        <span key={i} className="block">{word}</span>
                    ))}
                </h1>
                <div className="border-b-2 border-white mb-24"></div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
                    <div className="col-span-12 md:col-span-4">
                        <ArrowDown size={64} className="mb-8" />
                        <h2 className="text-4xl font-bold leading-tight mb-8">
                            We believe that words have power.
                        </h2>
                    </div>
                    <div className="col-span-12 md:col-span-8 flex flex-col gap-12">
                        <p className="text-4xl md:text-6xl font-light leading-tight opacity-90 indent-12">
                            Education is not just about filling a bucket, but lighting a fire. We specialize in the art of communication, design, and critical thinking.
                        </p>
                        
                        <div className="grid grid-cols-2 gap-8 mt-12 border-t border-white/50 pt-8">
                            <div>
                                <h3 className="text-sm font-bold uppercase tracking-widest mb-4 opacity-70">Programs</h3>
                                <ul className="text-xl font-bold space-y-2">
                                    <li className="flex items-center justify-between border-b border-white/30 py-2 cursor-pointer hover:pl-4 transition-all">Graphic Design <ArrowUpRight size={16} /></li>
                                    <li className="flex items-center justify-between border-b border-white/30 py-2 cursor-pointer hover:pl-4 transition-all">Typography <ArrowUpRight size={16} /></li>
                                    <li className="flex items-center justify-between border-b border-white/30 py-2 cursor-pointer hover:pl-4 transition-all">Art Direction <ArrowUpRight size={16} /></li>
                                </ul>
                            </div>
                            <div className="flex flex-col justify-end">
                                 <Button className="w-full h-20 bg-white text-[#FF3333] text-2xl font-bold uppercase rounded-none hover:bg-black hover:text-white transition-colors border-2 border-transparent hover:border-white">
                                     Enroll Now
                                 </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default TypographicPoster;
